export default __webpack_public_path__ + "static/media/xBrown.6c22aa54.svg";